import React, { useRef, useEffect } from "react";
import "./gameInfo.scss";

const serverInfo = [
  { label: "Server Version", value: "Season 0.99b" },
  { label: "Experience Rate (EXP)", value: "150x" },
  { label: "Drop Rate", value: "30%" },
  { label: "Max Level", value: "400" },
  { label: "Reset", value: "Level 400" },
  { label: "Grand Reset", value: "Disable for Now" },
  { label: "Max Stats", value: "32767" },
  { label: "Points per Level", value: "7 / 7 / 5 (DL / MG / OTHER)" },
];

const GameInfo = () => {
  const scrollTargetRef = useRef(null);
  useEffect(() => {
    const yOffset = -80; // 🔧 תכוון כאן לפי גובה ה-header שלך
    const y =
      scrollTargetRef.current.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  return (
    <div ref={scrollTargetRef} className="gameinfo-container">
      <h2 className="gameinfo-title">SERVER GAME INFO</h2>
      <table className="gameinfo-table">
        <tbody>
          {serverInfo.map((info, index) => (
            <tr key={index}>
              <td className="label">{info.label}</td>
              <td className="value">{info.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GameInfo;
